import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IcalChannel } from '../../../interfaces/channel.interface';

@Component({
  standalone: true,
  selector: 'ui-icon-ical-platform',
  templateUrl: './icon-ical-platform.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class IconIcalPlatformComponent {
  @Input({ required: true }) platform!: IcalChannel;

  Channel = IcalChannel;

  hasChannelPlatform(platform: IcalChannel): boolean {
    return Object.values(IcalChannel).indexOf(platform) !== -1;
  }
}
